import React from 'react';
import { actions } from 'react-redux-toastr';

export const toastrSuccess = (title: string, message?: string) =>
  actions.add({
    title: <div data-testid="toaster-success-title">{title}</div>,
    message: <div data-testid="toaster-success-message">{message}</div>,
    type: 'success',
  });

export const toastrWarning = (title: string, message?: string) =>
  actions.add({
    title: <div data-testid="toaster-warning-title">{title}</div>,
    message: <div data-testid="toaster-warning-message">{message}</div>,
    type: 'warning',
  });

export const toastrError = (title: string, message?: string) =>
  actions.add({
    title: <div data-testid="toaster-error-title">{title}</div>,
    message: <div data-testid="toaster-error-message">{message}</div>,
    type: 'error',
  });
